import React, { useContext } from "react";
import CommonModal, { CommonModalProps } from "../CommonModal";
import { Text } from "@src/components/Text";
import { ModalContext, ModalType } from "@src/components/modals/ModalController";
import { graphql, useStaticQuery } from "gatsby";
import { Box, Flex } from "@src/components/Boxes";
import SignupForm, { SignupFormDataInput } from "../SignupForm";
import Translate from "../../translation/Translate";
import { logEvent as le } from "@src/utils/logClient";
import { useTeacherSignupMobileRedesign } from "@src/hooks/useTeacherSignupMobileRedesign";
import {
  LinkButton,
  LogoBadge,
  getTitleComponent,
  getMobileRedesignTextProps,
  getMobileRedesignModalProps,
} from "../shared/MobileRedesignComponents";

const SchoolLeaderSignupModal = (props: CommonModalProps & { formData: SignupFormDataInput; fullPage?: boolean }) => {
  const data = useStaticQuery(graphql`
    {
      badge: file(name: { eq: "school_leader_badge" }) {
        childImageSharp {
          gatsbyImageData(width: 88, quality: 90, placeholder: NONE, layout: FIXED)
        }
      }
    }
  `);

  const { badge } = data;

  const modalContext = useContext(ModalContext);
  const useMobileDesign = useTeacherSignupMobileRedesign();
  const ModalTitleComponent = getTitleComponent(useMobileDesign);
  const textProps = getMobileRedesignTextProps(useMobileDesign);

  function showLoginModal() {
    modalContext.showModal(ModalType.SchoolLeaderLogin);
  }

  return (
    <CommonModal noHeader {...getMobileRedesignModalProps(useMobileDesign)} {...props}>
      <LogoBadge
        isMobileOptimized={useMobileDesign}
        badge={badge}
        badgeAlt="Identifying badge icon"
        badgeStyles={{ margin: "15px 0" }}
      />
      <Flex flexDirection="column" alignItems="center" maxWidth={["100%", props.fullPage ? "545px" : "85%"]} mx="auto">
        <ModalTitleComponent as="h1">
          <Translate path="components.signup_teacher.ab_title_leader" />
        </ModalTitleComponent>
        <Box>
          <Text display="inline-block" {...textProps}>
            <Translate path="components.signup_teacher.subtitle" />
          </Text>
          <LinkButton
            onClick={() => {
              le({
                eventName: "web.school_leader.user_signup.signup_form.login_instead.tap",
                eventValue: "domain_email_signup_overlay_variant",
              });
              showLoginModal();
            }}
          >
            <Translate path="components.signup_teacher.log_in_here" />
          </LinkButton>
        </Box>
        <SignupForm userType="school_leader" formData={props.formData} newStyles={useMobileDesign} />
      </Flex>
    </CommonModal>
  );
};

export default SchoolLeaderSignupModal;
